import { Grid, styled } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'

const LoadingWrapperGrid = styled(Grid)({
  width: '100vw',
  height: '100vh',
})

const ContentLoadingWrapperGrid = styled(Grid)({
  width: '100vw',
  height: 300,
})

const Loading = () => {
  return (
    <LoadingWrapperGrid container direction="column" alignItems="center" justifyContent="center">
      <Grid item>
        <CircularProgress />
      </Grid>
    </LoadingWrapperGrid>
  )
}

export const ContentLoading = () => {
  return (
    <ContentLoadingWrapperGrid container direction="column" alignItems="center" justifyContent="center">
      <Grid item>
        <CircularProgress />
      </Grid>
    </ContentLoadingWrapperGrid>
  )
}

export default Loading
